import { cn } from '@/lib/utils';

export const Logo = ({ className }: { className?: string }) => {
  return (
    <div className={cn('flex items-center gap-2 text-foreground', className)}>
      {/*
       * Roman, not italic: Fraunces' WONK axis (via `type-wonk`) carries the
       * character the italic used to, without loading a whole italic font file
       * for one word. Swap `type-wonk` for `italic` to restore the old wordmark.
       */}
      {/* Steps down on phones — 36px of wordmark eats the fold on a 375px screen. */}
      <span className="font-display type-wonk text-3xl font-semibold leading-none sm:text-4xl">
        Boundr
      </span>
    </div>
  );
};
